import { connect } from 'react-redux';
import locator from 'utils/locator';
import urls from 'constants/urls';
import { hideEditModal } from 'redux/modules/address/actions';
import historyUtils from 'utils/history';
import EditAddressView from './EditAddressView';

const mapDispatchToProps = dispatch => ({
  onBackClick: () => {
    dispatch(hideEditModal());
    historyUtils.replace(`${locator.pathname}${locator.search}${urls.addressModals.choose}`);
  },
});

export default connect((state, props) => ({ ...props }), mapDispatchToProps)(EditAddressView);
